import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/subtypes/repair/todo_templates/Page";

export const PATH = `/settings/subtypes/repair/todo_templates`;

function Home() {
	return (
		<>
			<NskHead title="TODOテンプレート" />
			<Component />
		</>
	);
}

export default Home;
